import { action, makeAutoObservable, observable } from 'mobx';
import { TradeTalkStrategy } from '@monorepo/client-types';
import { type Layout } from '@the5erscom/web-charts';

export interface SpeakYourMindDraft {
  title: string;
  content: string;
  currentStep: number;
  isPublic: boolean;
  strategy: TradeTalkStrategy;
  categories: string;
  categoryNames: string;
  tags: string;
  chartData: Layout | undefined;
}

export class SidebarStore {
  @observable
  speakYourMindDraft: SpeakYourMindDraft = {
    title: '',
    content: '',
    currentStep: 0,
    isPublic: true,
    strategy: TradeTalkStrategy.Long,
    categories: '',
    categoryNames: '',
    tags: '',
    chartData: undefined,
  };

  @observable
  isSubmitting = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  updateSpeakYourMindDraft = (draft: Partial<SpeakYourMindDraft>) => {
    this.speakYourMindDraft = { ...this.speakYourMindDraft, ...draft };
  };

  @action
  setIsSubmitting = (value: boolean) => {
    this.isSubmitting = value;
  };

  @action
  clearSpeakYourMindDraft = () => {
    this.speakYourMindDraft = {
      title: '',
      content: '',
      currentStep: 0,
      isPublic: true,
      strategy: TradeTalkStrategy.Long,
      categories: '',
      categoryNames: '',
      tags: '',
      chartData: undefined,
    };
  };
}
